// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    // Optional
    loadProductFirst: true,
    styleScrollToTop: 'style2',
    defaultDisplay: boostPFSThemeConfig.custom.layout,
    showPlaceholderProductList: true,
    swatchStyle: 'square-list',
  },
  colorFamily: {
    parentFilterOptionID: 'pf_t_color_family',
    childFilterOptionID: 'pf_t_color'
  }
};

(function() {
  BoostPFS.inject(this);

  ProductGridItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/
//     if(data.tags.includes("ACTS-TEMP")!=true){
    /* already hidden using products visibility option in app */

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add a specific class for grid item
    var itemGridWidthClass = '';
    var imageSize = '600x600';

    switch (boostPFSConfig.custom.products_per_row) {
      case 2:
        itemGridWidthClass = 'medium-up--one-half';
        imageSize = '540x600';
        break;
      case 3:
        itemGridWidthClass = 'small--one-half medium-up--one-third';
        imageSize = '345x550';
        break;
      case 4:
        itemGridWidthClass = 'small--one-half medium-up--one-quarter';
        imageSize = '250x';
        break;
      case 5:
        itemGridWidthClass = 'small--one-half medium-up--one-fifth';
        imageSize = '195x';
        break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    var imgId = 'ProductCardImage-' + data.id;
    var wrapperId = 'ProductCardImageWrapper-' + data.id;

    var options1 = boostPFSFilterConfig.colorFamily.parentFilterOptionID;
    var options2 = boostPFSFilterConfig.colorFamily.childFilterOptionID;
    var imgSelected = '';
    var selectedOptions1 = '';
    var selectedOptions2 = '';
    if (Globals.queryParams.hasOwnProperty(options1) || Globals.queryParams.hasOwnProperty(options2)) {
      if (Globals.queryParams.hasOwnProperty(options1)) {
        selectedOptions1 = Globals.queryParams[options1][0];
        selectedOptions1 = selectedOptions1.split('-');
        selectedOptions1 = Utils.slugify(selectedOptions1[selectedOptions1.length - 1]);
        
      }

      if (Globals.queryParams.hasOwnProperty(options2)) {
        selectedOptions2 = Globals.queryParams[options2][0];
        selectedOptions2 = selectedOptions2.split('-');
        selectedOptions2 = Utils.slugify(selectedOptions2[selectedOptions2.length - 1]);
      }

      for (var i = 0; i < images.length; i++) {
        var mKey = 'products\/' + images[i].src.split('\/products\/')[1];
        mKey = mKey.split('?v=')[0];
        
        var imgAlt = Utils.slugify(Utils.getProductMetafield(data, images[i].id, mKey) || '');
        if (imgAlt != '' && 
            (selectedOptions1 == imgAlt || 
             selectedOptions2 == imgAlt)) {
          imgSelected = images[i];
          break;
        }
      }
    }

    // console.log('imgSelected', imgSelected);
    // Build Image style
    var imageStyle = buildImageStyle(data);
    itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

    // Add Images
    var aspect_ratio = '';
    var imgSrc = imgSelected != '' ? Utils.optimizeImage(imgSelected.src, '300x300') : Utils.getFeaturedImage(images, '300x300');
    var imgDataSrc = imgSelected != '' ? Utils.optimizeImage(imgSelected.src, '{width}x') : Utils.getFeaturedImage(images, '{width}x');
    if (imgSelected != '') {

    }
    var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
    if (data.tags.includes('badge-NewThisYear')) {
      itemImagesHtml += '<img class="dynamic-product-badge" src="https://cdn.shopify.com/s/files/1/0434/4178/2939/files/NEW_2026_-_red_product_tag.png?v=1774369815" alt="new 2026 badge">';
    } else if(data.tags.includes('badge-SuperSale')) {
      itemImagesHtml += '<img class="dynamic-product-badge" style="width:30%" src="https://cdn.shopify.com/s/files/1/0434/4178/2939/files/super_sale.png?v=1743691761" alt="super sale badge">';
    }
      if (data.tags.includes('badge-TrendingNow')) {
       itemImagesHtml += `<img class="dynamic-product-badge trending" style="float: left;" src="https://cdn.shopify.com/s/files/1/0434/4178/2939/files/trending-now-badge.png?v=1776427879" alt="trending now badge">`; 
    }
    itemImagesHtml += '<div style="padding-top:';
    if (images.length > 0) {
      aspect_ratio = images[0]['width'] / images[0]['height'];
      itemImagesHtml += 1 / aspect_ratio * 100;
    } else {
      itemImagesHtml += 100;
    }
    itemImagesHtml += '%;">';
    itemImagesHtml += '<img id="' + imgId + '" ' +
      'class="grid-view-item__image lazyload" ' +
      'src="' + imgSrc + '" ' +
      'data-src="' + imgDataSrc + '" ' +
      'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
      'data-aspectratio="' + aspect_ratio + '" ' +
      'data-sizes="auto" ' +
      'alt="{{itemTitle}}">';
    itemImagesHtml += '</div>';
    itemImagesHtml += '</div>';

    var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
    var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
    itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

      // Add Reviews
//     itemHtml = itemHtml.replace(/{{itemReviews}}/g, {{ stars }} );
      
    // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    return itemHtml;
//     }
  }

  ProductListItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/
 
//     if(data.tags.includes("ACTS-TEMP")!=true){
    // Get Template
    var itemHtml = boostPFSTemplate.productListItemHtml;

    // Add onSale label
    var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
    var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
    itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    
     // Add Reviews
//     itemHtml = itemHtml.replace(/{{itemReviews}}/g, {{stars}});
    
    // Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    
    return itemHtml;
//   }
  }
  function buildReviews(data) {
    var html = '';
    var starCount = 0;
    var starTotalCount = 0;
    var average = 0;
    var metaReviews = data.metafields.filter(function(e) { return e.namespace == 'review'; });
    
    if (typeof metaReviews[0] !== 'undefined') {
      for (var i = 0; i < metaReviews.length; i++) {
        var meta = metaReviews[i];
        var metaValue = JSON.parse(meta.value);
        
        // Calculate
        if (metaValue.status == '1') {
          starCount++;
          starTotalCount += parseFloat(metaValue.star);
        }
      }
      var average = starTotalCount / starCount;
//       html += '<div class="product-reviews"><span>';
      if (starCount > 0) {
        var random = Math.floor((Math.random() * 10) + 1);
        html += '<div class="rating2">';
        html += '<label>';
        html += '<input type="radio" id="rating" name="review_rating'+random+'" value="1" ' + (average == 1 ? 'checked' : '') + ' />';
        html += '<span class="icon">★</span>';
        html += '</label>';
        html += '<label>';
        html += '<input type="radio" id="rating" name="review_rating'+random+'" value="2" ' + (average == 2 ? 'checked' : '') + ' />';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '</label>';
        html += '<label>';
        html += '<input type="radio" id="rating" name="review_rating'+random+'" value="3" ' + (average == 3 ? 'checked' : '') + ' />';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>'; 
        html += '</label>';
        html += '<label>';
        html += '<input type="radio" id="rating" name="review_rating'+random+'" value="4" ' + (average == 4 ? 'checked' : '') + ' />';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '</label>';
        html += '<label>';
        html += '<input type="radio" id="rating" name="review_rating'+random+'" value="5" ' + (average == 5 ? 'checked' : '') + ' />';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '<span class="icon">★</span>';
        html += '</label>';
        html += '</div>';
//         html += '<a href="#allreview" id="allreviewbutton">All Reviews (' + starCount + ')</a>';
      }
//       html += '</span></div>';
    }
    
   
    return html;
  }
  
  // Build Image style
  function buildImageStyle(data) {
    var images = data.images_info;
    var imgId = 'ProductCardImage-' + data.id;
    var wrapperId = 'ProductCardImageWrapper-' + data.id;
    var imageStyle = '';
    if (images.length > 0) {
      var image = images[0];
      var width = boostPFSConfig.custom.max_height;
      var height = boostPFSConfig.custom.max_height;
      var aspect_ratio = image.width / image.height;
      var small_style = true;
      var container_aspect_ratio = width * 1.0 / height;

      if (image.aspect_ratio < 1.0) {
        var maximum_width = height * aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          maximum_width = image.width;
        } else {
          var maximum_height = height;
        }
      } else if (aspect_ratio < container_aspect_ratio) {
        var maximum_height = height / aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          var maximum_width = image.width;
        } else {
          var maximum_height = height;
          var maximum_width = height * aspect_ratio;
        }
      } else {
        var maximum_height = height / aspect_ratio;
        if (image.width <= width) {
          maximum_height = image.height;
          var maximum_width = image.width
        } else {
          var maximum_width = width;
          maximum_height = maximum_width / aspect_ratio;
        }
      }

      imageStyle += '<style>';
      if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
      imageStyle += '#' + imgId + ' {' +
        'max-width: ' + maximum_width + 'px;' +
        'max-height: ' + maximum_height + 'px;' +
        '}' +
        '#' + wrapperId + ' {' +
        'max-width: ' + maximum_width + 'px;' +
        'max-height: ' + maximum_height + 'px;' +
        '}';
      if (small_style) imageStyle += '}';

      if (small_style) {
        if (aspect_ratio < 1) {
          maximum_width = 750 * aspect_ratio;
        } else {
          if (image.width < 750) {
            maximum_width = image.width;
          } else {
            maximum_width = 750;
          }
        }
        imageStyle += '@media screen and (max-width: 749px) {'
        imageStyle += '#' + imgId + ' {' +
          'max-width: ' + maximum_width + 'px;' +
          'max-height: 750px;' +
          '}' +
          '#' + wrapperId + ' {' +
          'max-width: ' + maximum_width + 'px;' +
          '}';
        imageStyle += '}';
      }
      imageStyle += '</style>';
    }
  
    return imageStyle;
    
   
  }

  function buildPrice(data, onSale, priceVaries) {
    var priceHtml = '',
      onSaleClass = onSale ? ' price--on-sale' : '';

    priceHtml += '<dl class="price price--listing ' + onSaleClass + '" data-price>';
    if (boostPFSConfig.custom.vendor_enable) {
      priceHtml += '<div class="price__vendor">';
      priceHtml += '<dt>';
      priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
      priceHtml += '</dt>';
      priceHtml += '<dd>';
      priceHtml += data.vendor;
      priceHtml += '</dd>';
      priceHtml += '</div>';
    }
    priceHtml += '<div class="price__regular">';
    priceHtml += '<dt>';
    priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
    if (data.available) {
      if (onSale) {
        priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
      } else {
        if (priceVaries) {
          priceHtml += boostPFSThemeConfig.label.from_price.replace(/{{ lowest_price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
        } else {
          priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
        }
      }
    } else {
      priceHtml += boostPFSConfig.label.sold_out;
    }
    priceHtml += '</span>';
    priceHtml += '</dd>';
    priceHtml += '</div>';

    priceHtml += '<div class="price__sale">';
    priceHtml += '<dt>';
    priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
    if (priceVaries) {
      priceHtml += boostPFSThemeConfig.label.from_price.replace(/{{ lowest_price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
    } else {
      priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
    }
    priceHtml += '</span> ';
    priceHtml += '</dd>';
    priceHtml += '<div class="price__compare">'
    priceHtml += '<dt>';
    priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<s class="price-item price-item--regular">';
    priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
    priceHtml += '</s>';
    priceHtml += '</dd>';
    priceHtml += '</div>';

    if (onSale) {
    priceHtml += '<div class="price__badges price__badges--listing">';
    priceHtml += '<span class="price__badge price__badge--sale" aria-hidden="true">';
    priceHtml += '<span>' + boostPFSThemeConfig.label.sale + '</span>';
    priceHtml += '</span>';
    priceHtml += '<span class="price__badge price__badge--sold-out">';
    priceHtml += '<span>' + boostPFSThemeConfig.label.sold_out + '</span>';
    priceHtml += '</span>';
    priceHtml += '</div>';

    priceHtml += '</div>';
    priceHtml += '</dl>';
    }

//     console.log('colllxxxx11')
 
    return priceHtml;
  }

  /// Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    if (Settings.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Build page items
      var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

    
       
      return paginationHtml;
    }
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Display type
  ProductDisplayType.prototype.compileTemplate = function() {
    var itemHtml = '<span>View As </span>';
    itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
    itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
    itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

    
    
    
    return itemHtml;
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    
    
    var productSelector = jQ(Selector.products);
    if (Globals.queryParams.display == 'list') {
      if (productSelector.children('.list-view-items').length == 0) {
        productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
      }
      productSelector.removeClass('grid grid--uniform grid--view-items');
    } else {
      if (productSelector.children('.list-view-items').length > 0) {
        productSelector.children('.list-view-items').children().unwrap();
      }
      productSelector.addClass('grid grid--uniform grid--view-items');
    }
  }

  // Build Additional Elements
  FilterResult.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    var totalProduct = '';
    if (data.total_product == 1) {
      totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct);

//     console.log("testing");
    console.log('collectionss')
      if(typeof WSAIO !== "undefined" && typeof WSAIO.productDiscount === "function"){
        setTimeout(function(){
          console.log('colllxxxx')
          $('.grid-view-item.product-card').each(function(){
            console.log("running");
            var _this= $(this);
            var handle = _this.find('.grid-view-item__image-container').attr('href');
            if(handle != undefined && handle != '#' && handle.indexOf("/products/") > -1){
              handle=handle.split('/products/')[1];
              handle=handle.split('?')[0];
              jQuery.getJSON('/products/'+handle+'.js', function(product) {
                _this.find('.price.price--listing ').addClass('wsaio-pid-'+product.id);
                WSAIO.productDiscount({
                  template:'collection',
                  product_id: product.id,
                  product_handle: product.handle,
                  variant_id: product.variants[0].id,
                  variant_sku: product.variants[0].sku,
                  variant_price: product.variants[0].price,
                  variant_compare_at_price: product.variants[0].compare_at_price
                });
              });
            };
          })
        },1000)
      }
    
//     if (!Utils.isMobile()) {
//       if (data.event_type != "init") {
//         jQ('body,html').animate({
//           scrollTop: jQ(".boost-pfs-filter-toolbar-item").offset().top
//         }, 600);
//       }
//     }
    
    
    /* boost#63304 */
    var stickyElemet = '.boost-pfs-filter-tree-v';
    var startElement = '.boost-pfs-filter-products';
    var endElement = '.boost-pfs-filter-bottom-pagination';
    var offSetElement = '.filters-toolbar';
    var footerElement = '.site-footer';
    stickTo(stickyElemet, startElement);
    /* End boost#63304 */
  };

  
   /* Boost - 63304 */
  // jQ.fn.stickTo = function(startElement) {
  function stickTo (stickyElement, startElement) {
    /* constants */    
    var showingHeader = false;
    var $headerHeight = 0; /* change the header height here */
    var $marginTop = 0;    
    var $window = jQ(window);  
    var $startElement = jQ(startElement);               
    // var _this = this;          
    var _this = jQ(stickyElement)          

    /* variables */
    var lastScrollTop = $window.scrollTop();  

    /* sticky method */
    var setPosition = function() {
        /* declarations */
        var width = jQ(_this).outerWidth();
        var $windowHeight = $window.height();
        var $contentHeight = $startElement.outerHeight(true);  
        var $contentPositionTop = $startElement.position().top;      
        var $contentTop = $startElement.offset().top;      

        var sidebarHeight = _this.outerHeight();
        var sidebarTop = _this.offset().top;
        var sidebarBottom = sidebarTop + sidebarHeight;

        var scrollTop = $window.scrollTop();                        
        var scrollBottom = scrollTop + $windowHeight;  
        var isScrollingDown = (scrollTop > lastScrollTop);

        var endPos = $contentTop + $contentHeight;        

        if (sidebarHeight > $contentHeight) {
          _this.removeClass('bc-sf-filter-stick');            
          _this.css({
            position: 'initial',
            width: '20%'
          });
          return;
        }

        if (scrollTop <= $contentTop) { /* Initial Position */
            _this.removeClass('bc-sf-filter-stick');            
            _this.css({
              position: 'initial',
              width: '20%'
            });
          return;
        }      

        if ((scrollBottom >= endPos)) { /* End Position  */          
            var absolutePos = endPos - sidebarHeight - $contentTop;
            if (absolutePos > 0) {
              _this.removeClass('bc-sf-filter-stick');              
              _this.css({
                  position: 'absolute',
                  top: absolutePos,
                  bottom: 'unset',
                  width: width
              });
            } 
          return;
        }


        /* when scrolling down */  
        if (isScrollingDown) {          
          if (scrollBottom < sidebarBottom) { /* Until reach the sidebar bottom  */
            if (_this.css('position') !== 'relative') {
              _this.removeClass('bc-sf-filter-stick');            
              _this.css({
                position: 'relative',
                top: sidebarTop - $contentTop,
                bottom: 'unset'
              });          
            }
          } else if (scrollBottom >= sidebarBottom && scrollTop > $contentTop) { /* Sticky sidebar */                
              _this.addClass('bc-sf-filter-stick');                          

              _this.css({
                  position: 'fixed',
                  top: $windowHeight > (sidebarHeight + $headerHeight) ? $headerHeight : 'unset',
                  bottom: $windowHeight > (sidebarHeight + $headerHeight) ? 'unset' : 0,
                  width: width
              });
          }
        } else { /* when scrolling up */     
          if ((scrollTop - $headerHeight) > sidebarTop) {  /* Until reach the sidebar top  */   
            if (_this.css('position') !== 'relative') {
              _this.removeClass('bc-sf-filter-stick');            
              _this.css({
                position: 'relative',
                top: sidebarTop - $contentTop,
                bottom: 'unset'
              });          
            }
          } else if (scrollTop <= (endPos - sidebarHeight)) { /* Sticky sidebar */
            _this.addClass('bc-sf-filter-stick');                        

            _this.css({
                position: 'fixed',
                top:  showingHeader ? ($headerHeight + 'px') : '0',
                bottom: 'unset',
                width: width
            });
          }
        }

  /* save last scroll position */
          lastScrollTop = $window.scrollTop();
  };

    /* on window resize */
    jQ(window).resize(function() {        
        setPosition();
    });

    /* on scroll */
    jQ(window).scroll(setPosition);
    setPosition();
    
    jQ(document).on('click', '.boost-pfs-filter-button.boost-pfs-filter-option-title-heading', function() {
      setTimeout(setPosition, 400);
    });
  };
  
    function resize() {
       /* boost#63304 */
      var stickyElemet = '.boost-pfs-filter-tree-v';
      var startElement = '.boost-pfs-filter-wrapper';
      var endElement = '.boost-pfs-filter-bottom-pagination';
      var offSetElement = '.filters-toolbar';
      var footerElement = '.site-footer';
      // jQ(stickyElemet).stickTo(startElement, endElement, offSetElement, footerElement);
      stickTo(stickyElemet, startElement)
      
      /* End boost#63304 */
    }

  /* End boost - 63304 */
  

  /* start-boost-custom */
  // #boost-48107 */
  FilterOptionItemSwatch.prototype.getTemplate = function() {
    return '<li class="{{class.filterOptionItem}} {{disabled}} {{swatchBorder}}">' +
      '<span class="boost-pfs-filter-option-swatch-image" ' +
      'style="background-image: {{swatchFileUrl}};" title="{{label}}"> ' +
      '<span style="background-image: {{swatchFileUrl}}" class="tooltiptext"><p>{{tooltip}}</p></span>' +
      '</span>' +
      '<button class="{{class.button}}"> ' +
      '<span class="boost-pfs-check-box"></span>' +
      '<span class="boost-pfs-filter-option-value">{{label}}</span>' +
      '<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>' +
      '</button>' +
      '</li>';
  };

  FilterOptionItemSwatch.prototype.compileTemplate = function() {
    var gradient = this.label.split('-');
    var bg = gradient.length > 1 ? 'linear-gradient(-45deg,#' + gradient[0] + ',#' + gradient[1] + ')' : this.swatchFileUrl;
    var label = gradient.length > 2 ? gradient[2] : this.label;

    return this.getTemplate()
      .replace(/{{class.filterOptionItem}}/g, Class.filterOptionItem)
      .replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
      .replace(/{{disabled}}/g, this.isDisabled() ? 'disabled' : '')
      .replace(/{{class.button}}/g, Class.button)
      .replace(/{{label}}/g, label)
      .replace(/{{countLabel}}/g, this.countLabel)
      .replace(/{{backgroundColor}}/g, this.backgroundColor)
      .replace(/{{swatchBorder}}/g, this.swatchBorder)
      .replace(/{{swatchFileUrl}}/g, bg)
      .replace(/{{tooltip}}/g, label);
  };

  var refineTemplate = FilterRefineByItem.prototype.getTemplate;

  FilterRefineByItem.prototype.getTemplate = function() {
    if (this.type === 'COLOR' || this.type === 'COLOR FAMILY') {
      //         return '<div class="refine-by-item {{class.filterOptionLabel}}">' +
      //            '<a tabindex="0" role="button" href="javascript:;" class="boost-pfs-color-refine">' +
      //              '<span class="refine-by-type">' +
      //                '<span>{{type}}</span>' +
      //                  '<span class="boost-pfs-filter-option-swatch-image" style="background-image: {{color}};" title="{{label}}"><span style="background-image: {{color}}" class="tooltiptext"><p>{{label}}</p></span></span>' +                                                                    
      //              '</span>' +
      //              '{{clearButton}}' +
      //            '</a>' +
      //          '</div>';
//       return '<div class="refine-by-item {{class.filterOptionLabel}}">' +
//         '<a tabindex="0" role="button" href="javascript:;" class="boost-pfs-color-refine">' +
//         '<span class="refine-by-type">' +
//         '<span>{{type}} </span>' +
//         '<strong> {{label}}</strong>'
//       '</span>' +
//       '{{clearButton}}' +
//       '</a>' +
//       '</div>';
    }
    return refineTemplate.call(this);
  };

  FilterRefineByItem.prototype.compileTemplate = function() {
    var label = this.label;
    var bg = '';

    if (this.type === 'COLOR' || this.type === 'COLOR FAMILY') {
      var array = label.split('-');
      if (array.length > 2) label = array[2];
      bg = array.length > 1 ? 'linear-gradient(-45deg,#' + array[0] + ',#' + array[1] + ')' : '';
    }

    var html = this.getTemplate()
      .replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
      .replace(/{{type}}/g, this.type ? this.type + ': ' : '')
      .replace(/{{label}}/g, label)
      .replace(/{{clearButton}}/g, '')
      .replace(/{{color}}/g, bg);

    return html;
  };

  var filterSortValues = FilterOption.prototype.sortValues;

  FilterOption.prototype.sortValues = function(values) {
    var colorOptions = ['pf_t_color', 'pf_t_color_family'];

    if (colorOptions.indexOf(this.filterOptionId) > -1) {
      if (values && values.length > 0) {
        values.sort(function(a, b) {
          return calcHue(a.key) - calcHue(b.key);
        });
      }
    } else {
      filterSortValues.call(this, values);
    }
  };

  function calcHue(tag) {
    var array = tag.split('-');
    var color = array[1];

    /* Get the RGB values to calculate the Hue. */
    var r = parseInt(color.substring(0, 2), 16) / 255;
    var g = parseInt(color.substring(2, 4), 16) / 255;
    var b = parseInt(color.substring(4, 6), 16) / 255;

    /* Getting the Max and Min values for Chroma. */
    var max = Math.max.apply(Math, [r, g, b]);
    var min = Math.min.apply(Math, [r, g, b]);

    var chr = max - min;
    var hue = 0;
    var val = max;
    var sat = 0;

    if (val > 0) {
      /* Calculate Saturation only if Value isn't 0. */
      sat = chr / val;
      if (sat > 0) {
        if (r == max) {
          hue = 60 * (((g - min) - (b - min)) / chr);
          if (hue < 0) {
            hue += 360;
          }
        } else if (g == max) {
          hue = 120 + 60 * (((b - min) - (r - min)) / chr);
        } else if (b == max) {
          hue = 240 + 60 * (((r - min) - (g - min)) / chr);
        }
      }
    }

    return hue;
  }

  // #boost-51360
  var configColorFamily = boostPFSAppConfig.colors;
  var setDataFilterOption = FilterOption.prototype.setData;

  FilterOption.prototype.setData = function(data) {
    if (Globals.queryParams.hasOwnProperty(boostPFSFilterConfig.colorFamily.parentFilterOptionID) &&
      Globals.queryParams[boostPFSFilterConfig.colorFamily.parentFilterOptionID].length > 0 &&
      data.filterOptionId == boostPFSFilterConfig.colorFamily.childFilterOptionID) {

      this.status = data.status;
      this.position = data.position;
      this.label = Utils.stripHtml(Utils.stripScriptTag(data.label));
      this.filterOptionId = data.filterOptionId;
      this.filterType = data.filterType;
      this.displayType = data.displayType;
      this.selectType = data.selectType;
      this.valueType = data.valueType;
      this.displayTypeItem = data.displayTypeItem;
      this.manualValues = data.manualValues ? data.manualValues : [];
      this.prefix = data.prefix;
      this.isCollapsePC = data.isCollapsePC;
      this.isCollapseMobile = data.isCollapseMobile;
      this.showSearchBoxFilterPC = data.showSearchBoxFilterPC;
      this.showSearchBoxFilterMobile = data.showSearchBoxFilterMobile;
      this.keepValuesStatic = data.keepValuesStatic;
      this.activeCollectionAll = data.activeCollectionAll;
      this.tooltip = data.tooltip;
      this.showMoreType = data.showMoreType == null || data.showMoreType == '' ? FilterOptionEnum.ShowMoreType.SCROLLBAR : data.showMoreType;
      this.sortType = data.sortType;
      this.sortManualValues = data.sortManualValues;
      this.displayAllValuesInUppercaseForm = data.displayAllValuesInUppercaseForm;
      this.useAndCondition = data.useAndCondition;
      this.showExactRating = data.showExactRating;
      this.starColor = Utils.stripHtml(Utils.stripScriptTag(data.starColor));
      this.displayColumn = data.displayColumn ? data.displayColumn : Settings.getSettingValue('general.filterHorizontalColumn');

      this.children = [];
      this.filterItems = new Map();

      var modifiedValues = [];
      if (data.values) {
        if (!Array.isArray(data.values)) {
          modifiedValues = [data.values];
        } else {
          modifiedValues = data.values;
        }
      } else if (data.manualValues) {
        if (!Array.isArray(data.manualValues)) {
          modifiedValues = [data.manualValues];
        } else {
          modifiedValues = data.manualValues;
        }
      }

      if (this.isSortValues()) {
        this.sortValues(modifiedValues);
      }

      // Add or remove from values
      this.modifyValues(modifiedValues);

      // If the array is too long, we only render the first ones
      this.markValuesAsNoRender(modifiedValues);

      modifiedValues.forEach((itemData) => {
        var item = null;
        switch (this.displayType) {
          case FilterOptionEnum.DisplayType.LIST:
            item = new FilterOptionItemList(this.filterTreeType);
            break;
          case FilterOptionEnum.DisplayType.BOX:
            item = new FilterOptionItemBox(this.filterTreeType);
            break;
          case FilterOptionEnum.DisplayType.SWATCH:
            item = new FilterOptionItemSwatch(this.filterTreeType);
            break;
          case FilterOptionEnum.DisplayType.RATING:
            item = new FilterOptionItemRating(this.filterTreeType);
            break;
          case FilterOptionEnum.DisplayType.RANGE:
            item = new FilterOptionItemRangeSlider(this.filterTreeType);
            break;
          case FilterOptionEnum.DisplayType.SUB_CATEGORY:
            item = new FilterOptionItemSubCategory(this.filterTreeType);
            break;
          case FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS:
            item = new FilterOptionItemMultiLevelCollections(this.filterTreeType);
            break;
          case FilterOptionEnum.DisplayType.MULTI_LEVEL_TAG:
            item = new FilterOptionItemMultiLevelTag(this.filterTreeType);
            break;
          default:
            break;
        }
        if (!item) {
          return;
        }
        this.addComponent(item);
        item.setData(itemData);

        var selectedColorFamily = Globals.queryParams[boostPFSFilterConfig.colorFamily.parentFilterOptionID][0].split('-');
        selectedColorFamily = selectedColorFamily[selectedColorFamily.length - 1].toLowerCase();

        var colorFamilyLabel = item.value.split('-');
        colorFamilyLabel = colorFamilyLabel[colorFamilyLabel.length - 1];

        if (configColorFamily[selectedColorFamily].indexOf(colorFamilyLabel) > -1) {

          var itemKey = item.key ? item.key : item.value;
          this.filterItems.set(itemKey, item);
          // console.log(this.filterItems);
        }
      });
    } else {
      setDataFilterOption.call(this, data);
    }

  };
  /* end-boost-custom */
  
  /* start-boost-65828 */
  var buildLabelRefineBy = FilterRefineByItem.prototype.buildLabel;
  
  FilterRefineByItem.prototype.buildLabel = function () {
    var label = buildLabelRefineBy.call(this);
    
    if (this.filterOptionId === 'pf_t_color' && label && label.indexOf('-') >= 0) {
      var tmp = label.split('-');
      label = tmp[tmp.length - 1];
    }
     if (this.filterOptionId === 'pf_t_color_family' && label && label.indexOf('-') >= 0) {
      var tmp = label.split('-');
      label = tmp[tmp.length - 1];
    }
    
    return label;
  }
  /* end-boost-65828 */
  
  
  FilterOptionItem.prototype.isRender = function() {
    var filterOption = this.filterOption ? this.filterOption : this.parent;
//     if(filterOption.filterType === "tag" && filterOption.prefix === "size" && this.value.indexOf("#MWS") > -1){
    /* No matter what's the filter type or prefix; ignore the option if it's a variant created at runtimeby Advance Product Options App*/ 
        if(this.value.indexOf("#MWS") > -1){	
    return false;	
    }
    var validDocCount = this.hasOwnProperty("docCount") && (this.docCount > 0 || this.docCount === null);
    var isExactStarRating = filterOption.filterType == FilterOptionEnum.FilterType.REVIEW_RATINGS && filterOption.showExactRating;
    var isStaticCollection = filterOption.filterType == FilterOptionEnum.FilterType.COLLECTION && (filterOption.keepValuesStatic || this.handle == 'all');
    var isMultiLevelCollectionTag = (filterOption.displayType == FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS && this.level != 1);
    var isShowOutOfStock =  Settings.getSettingValue('general.showOutOfStockOption');
    return isExactStarRating || isStaticCollection || isMultiLevelCollectionTag || validDocCount || isShowOutOfStock;
  }
})();

// Remove ?page=N from collection URLs
(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  const url = new URL(window.location.href);

  if (url.searchParams.has('page')) {
    url.searchParams.delete('page');

    // Replace URL without reloading page
    window.history.replaceState({}, '', url.toString());
  }
})();

/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
